import { ApiProperty } from "@nestjs/swagger";


export class locationWiseReq{
    @ApiProperty()
    locationId?: number;

    @ApiProperty()
    locationName? : string;

    @ApiProperty()
    plant?: number;
    
    @ApiProperty()
    plantId?: number;
    
   

}